import React, { FC } from "react";

import kagaminBigSmile from "~/assets/images/ai_icon/kagamin_big_smile.png";
import kagaminNeutralExpression from "~/assets/images/ai_icon/kagamin_neutral_expression.png";
import kagaminPeekingPose from "~/assets/images/ai_icon/kagamin_peeking_pose.png";
import kagaminStanding from "~/assets/images/ai_icon/kagamin_standing.png";

import { Avatar } from "~/components/atoms";

const AI_AVATAR_IMAGES = {
  bigSmile: kagaminBigSmile as string,
  neutralExpression: kagaminNeutralExpression as string,
  peekingPose: kagaminPeekingPose as string,
  standing: kagaminStanding as string,
} as const;

type AIAvatarType = keyof typeof AI_AVATAR_IMAGES;

type PropsType = {
  className?: string;
  type: AIAvatarType;
  size: "xs" | "sm" | "md" | "lg" | "xl";
  withRing?: boolean;
  autoHeight?: boolean;
};

export const AIAvatar: FC<PropsType> = ({
  className = "",
  type,
  size,
  withRing = false,
  autoHeight = false,
}: PropsType) => {
  return (
    <Avatar
      className={className}
      src={AI_AVATAR_IMAGES[type]}
      size={size}
      withRing={withRing}
      autoHeight={autoHeight}
    />
  );
};
